/**
 * Re-reads an instant's UTC fields as local-time fields, so system-local getters and `date-fns`
 * formatters report the UTC calendar date and time.
 *
 * The returned `Date` deliberately points at a different instant than the one passed in — it is a
 * display-only value. Never send it back to an API or compare it against a real timestamp.
 *
 * Intentionally hand-rolled rather than using `tz`/`TZDate` from `@date-fns/tz`: `TZDate` extends the
 * global `Date`, so it recurses infinitely wherever `Date` is swapped out (`timezone-mock`, fake timers).
 */
export const toUtcWallClock = (date: Date): Date => {
  const wallClock = new Date(0)

  wallClock.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  wallClock.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds())

  return wallClock
}
